import axios from 'axios';

const api = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8000/api',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        
        const savedYear = localStorage.getItem('selected_year');
        if (savedYear) {
            const year = JSON.parse(savedYear);
            config.headers['X-Academic-Year-ID'] = year.id;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);




api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('user');
            // Redirect to login handled efficiently in AuthContext or app logic
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        } else if (error.response && error.response.status === 403 && error.response.data && error.response.data.blocked) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('user');
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
